import './filme-info.css'
import { useParams, useHistory } from 'react-router-dom'
import {useEffect, useState,} from 'react'
import { toast } from 'react-toastify'

import api from '../../services/api';

export default function Filme(){
    const { id } = useParams();
    const history = useHistory();

    const [filme, setFilme] = useState();
    const [loading, setLoading] = useState(true);


    useEffect(()=>{

      async function loadFilme(){
            const response = await api.get(`r-api/?api=filmes/${id}`);
            //console.log(response.data)

            if(response.data.length === 0){
            // Se não existi o filme selecionado, renderizo para Home
                history.replace('/')
            return;
            }

            setFilme(response.data)
            setLoading(false)
        }

        loadFilme();

        return ()=>{
            console.log('COMPONENTE DESMONTADO')
        }

    }, [history, id]);


    function salvaFilme(){
        const minhaLista = localStorage.getItem('filmes');

        let filmeSalvos = JSON.parse(minhaLista) || [];

        // Se tiver algum filme salvo com esse ID, Tem que ignorar.

        const hasFilme = filmeSalvos.some((filmeSalvo) => filmeSalvo.id === filme.id)
        
        if(hasFilme){
            toast.error('Voce ja possui esse filme salvo!')
            return;
            // para a execucao do codigo aqui
        }

        filmeSalvos.push(filme);
        localStorage.setItem('filmes', JSON.stringify(filmeSalvos));
        toast.success('Filme salvo com sucesso!')
       


    }



    if(loading){
        return(
            <div>
                <h1> Carregando pagina...</h1>
            </div>
        )
    }

    return(
        <div className='filme-info'>
            <h1> {filme.nome} </h1>
            <img src={filme.foto} alt={filme.nome} />
            
            <h3 className='sipnose'> Sinopse </h3>
             <p className='paragrafoSipnose'> {filme.sinopse} </p> 

            <div className='botoes'>
                
                <button>
                     <a target='blank' href={`https://www.google.com/search?q=${filme.nome} filme online `}> Filme </a>        
                </button>

                <button>
                     <a target='blank' href={`https://youtube.com/results?search_query=${filme.nome} trailer `}>   Trailer </a>        
                </button>

                <button onClick={salvaFilme}> Salvar </button>
            </div>

        </div>
    )

}